import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./boot/router";
import device from "current-device";
import { DEV } from "@/utils/dispatchEnv";
import Vconsole from "vconsole";
import mockHandler from "@/mock/handler";
import Utils from "@/utils/functionTools";
import Jsbridge from "@/utils/jsbridge";
import "@/utils/analysysagent"; // 诸葛埋点
import wx from "weixin-js-sdk";
import VueLuckywheel from "vue-luckywheel";
import "vue-luckywheel/lib/vue-luckywheel.css";
import store from "./store";
import scrollList from "@/components/scroll/list";
import qs from "qs";
import VuevideoPlayer from "vue-video-player";
import loginPopup from "./plugin/loginPopup/loginPopup";
import share from "./plugin/share/share";
import loading from "./plugin/loading/loadingObj";
import md5 from "js-md5";
import ShareImg from "./utils/shareImg";
import "./utils/fontSize";
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
Vue.use(VuevideoPlayer);
const BrowserLogger = require("alife-logger");
Vue.prototype.$loginPopup = loginPopup.install; // 登陆弹窗
Vue.prototype.$share = share.install; // 分享弹窗
Vue.prototype.$loading = loading; // loading弹窗
Vue.use(VueLuckywheel);
Vue.prototype.$qs = qs;
Vue.component("scrollList", scrollList);
Vue.prototype.mockHandler = mockHandler;
Vue.prototype.getUrlParam = Utils.getUrlParam;
Vue.prototype.debouceClick = Utils.debouce;
Vue.prototype.jsbridge = new Jsbridge();
Vue.prototype.$utils = Utils;
Vue.prototype.$shareImg = ShareImg;
Vue.prototype.$md5 = md5;
Vue.use(VueRouter);
// 埋点
Vue.prototype.AnalysysAgent = window.zhuge;
Vue.prototype.CDNImgUrl =
  "https://activity-h5.starcharge.com/images/activity-image/";
Vue.prototype.$wx = wx;
Vue.config.ignoredElements = ['wx-open-launch-weapp']

window.rem2px = function(v) {
  v = parseFloat(v);
  return v * rem;
};

window.px2rem = function(v) {
  v = parseFloat(v);
  console.log(v / 75);
  return v / 75;
};

// 配置router
const router = new VueRouter({
  // mode: 'history',
  routes
});
router.beforeEach((to, from, next) => {
  console.log(to);
  if (to.query.titleFromNative && !to.meta.title) {
    document.title = to.query.titleFromNative;
    next();
    return;
  }
  if (to.query.title) {
    document.title = to.query.title;
    next();
    return;
  }
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});

// 页面加载、停留埋点
router.afterEach((to, from) => {
  const pages = new Map([
    ["/activity/starClassNew", "star_classroom"],
    ["/carbonTrace", "carbon_public"],
    ["/lowCarbonReport", "lowCarbonReport"],
    ["/yearBill2022", "2022bill"],
    ["/teamUp", "team_up"],
    ["/", "lottery_activity"]
  ]);
  const pageKey = pages.get(to.path) || "";
  if (pageKey) {
    zhugeStay(pageKey);
    zhuge.track("Pageload", {
      page_key: pageKey
    });
  }
});

/* eslint-disable no-new */
window.mount = new Vue({
  el: "#app",
  router,
  store,
  render: h => h("router-view")
});

/* vconsole */

if (DEV || !process.env.IS_PRO) {
  // 注意：某些情况下，Vconsole会导致页面死掉（原生跳h5，h5再跳原生）
  window.vCon = new Vconsole();
} else {
  window.browger = BrowserLogger.singleton({
    // ARMS
    pid: "gmpgmsbi3k@3b24804b86b284a",
    appType: "web",
    imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
    sendResource: true,
    enableLinkTrace: true,
    behavior: true
  });
}



// WEBPACK FOOTER //
// ./src/starcharge/main.js